import { useRef } from "react";
import { gsap, useGSAP, MOTION_OK } from "../gsap";
import { process } from "../content";

export function Process() {
  const root = useRef<HTMLElement>(null);

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        // Rows arrive in order because the steps happen in order.
        gsap.from(".process-row", {
          y: 64,
          opacity: 0,
          duration: 1.1,
          stagger: 0.14,
          ease: "expo.out",
          scrollTrigger: { trigger: ".process-list", start: "top 80%" },
        });
      });
    },
    { scope: root },
  );

  return (
    <section ref={root} id="process" className="bg-coal px-4 py-20 md:px-8 md:py-48">
      <div className="mx-auto max-w-[1400px]">
        <h2 className="max-w-4xl font-display text-[clamp(1.75rem,8.2vw,2.25rem)] md:text-[clamp(2.25rem,5vw,5rem)] font-extrabold uppercase leading-[0.92] tracking-[-0.04em]">
          How a commission works
        </h2>

        <ol className="process-list mt-10 divide-y divide-white/10 md:mt-24">
          {process.map((item) => (
            <li key={item.step} className="process-row group relative overflow-hidden">
              <span
                aria-hidden
                className="absolute inset-0 origin-bottom scale-y-0 bg-stab transition-transform duration-700 ease-heavy group-hover:scale-y-100"
              />
              <div className="relative grid grid-cols-1 items-end gap-3 px-2 py-8 transition-colors duration-500 ease-heavy group-hover:text-ink md:grid-cols-12 md:gap-8 md:px-6 md:py-12">
                <h3 className="font-display text-[clamp(2.5rem,6vw,6.5rem)] font-extrabold uppercase leading-[0.9] tracking-[-0.04em] md:col-span-7">
                  {item.step}
                </h3>
                <p className="max-w-[44ch] text-base leading-relaxed text-smoke transition-colors duration-500 ease-heavy group-hover:text-ink md:col-span-5 md:pb-2 md:text-lg">
                  {item.body}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
